import React from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { Box, Typography } from '@mui/material';
import { CatalogNode } from './catalogDoc';
import { CatalogPort } from './catalogPorts';
import { CatalogBlock } from './CatalogBlock';
import { useI18n } from '../i18n';

const HANDLE: React.CSSProperties = {
  width: 8,
  height: 8,
  position: 'relative',
  top: 'auto',
  transform: 'none',
};

const FlowNodeView: React.FC<NodeProps> = ({ data }) => {
  const { t } = useI18n();
  const node = data as CatalogNode;
  return (
    <CatalogBlock
      node={node}
      renderPort={(port, side) => <PortCell port={port} side={side} t={t} />}
    />
  );
};

function PortCell({
  port,
  side,
  t,
}: {
  port?: CatalogPort;
  side: 'left' | 'right';
  t: (key: string, vars?: Record<string, string | number>) => string;
}) {
  if (!port) {
    return <Box sx={{ width: 8 }} />;
  }
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, position: 'relative', flexDirection: side === 'right' ? 'row-reverse' : 'row' }}>
      <Handle
        type={port.dir === 'in' ? 'target' : 'source'}
        position={side === 'left' ? Position.Left : Position.Right}
        id={port.id}
        style={{
          ...HANDLE,
          left: side === 'left' ? -6 : 'auto',
          right: side === 'right' ? -6 : 'auto',
        }}
      />
      <Typography variant="caption" color="text.secondary">
        {port.label || t(`flow.port.${port.labelKey}`, port.n != null ? { n: port.n } : undefined)}
      </Typography>
    </Box>
  );
}

export const flowNodeTypes = {
  controller: FlowNodeView,
  bus: FlowNodeView,
  device: FlowNodeView,
  point: FlowNodeView,
  timer: FlowNodeView,
  calc: FlowNodeView,
  label: FlowNodeView,
  mqtt_topic: FlowNodeView,
  dashboard: FlowNodeView,
  threshold: FlowNodeView,
  notify: FlowNodeView,
  toggle: FlowNodeView,
};
